import create from "zustand";
import { RisorseAndRisorseTipologie } from "./prismaTypes";
import { SlotTariffa } from "./tabellone/SlotTariffa";
import { Orari } from "./utils/gruppaOrari";

export interface PrenotaState {
  giorno: Date;
  giornoPrenotazione: Date | null;
  risorsa: RisorseAndRisorseTipologie | undefined;
  orario: Orari;
  slotTariffe: { [k: string]: SlotTariffa };
  settimana: boolean;
  viewSet: boolean;
  setGiornoPrenotazione: (giornoPrenotazione: Date | null) => void;
  setOrario: (orario: Orari) => void;
  setRisorsa: (risorsa: RisorseAndRisorseTipologie) => void;
  setGiorno: (giorno: Date) => void;
  setSlotTariffe: (tariffe: { [k: string]: SlotTariffa }) => void;
  setSettimana: (settimana: boolean) => void;
  setViewSet: (viewSet: boolean) => void;
}

export const prenotaStore = create<PrenotaState>((set) => ({
  giorno: new Date(),
  giornoPrenotazione: new Date(),
  risorsa: undefined,
  orario: {
    oraInizio: "",
    oraFine: "",
  },
  slotTariffe: {},
  settimana: true,
  viewSet: false,
  setGiornoPrenotazione: (giornoPrenotazione: Date | null) => set({ giornoPrenotazione }),
  setOrario: (orario: Orari) => set((state) => ({ ...state, orario })),
  setRisorsa: (risorsa: RisorseAndRisorseTipologie) => set((state) => ({ ...state, risorsa })),
  setGiorno: (giorno: Date) => set((state) => ({ ...state, giorno })),
  setSlotTariffe: (slotTariffe: { [k: string]: SlotTariffa }) =>
    set((state) => ({ ...state, slotTariffe })),
  setSettimana: (settimana: boolean) => set((state) => ({ ...state, settimana })),
  setViewSet: (viewSet: boolean) => set((state) => ({ ...state, viewSet })),
}));
